import { ACCOUNT_INIT_QUERY_KEY } from "../appStore";
import { AuthInvalidationTypes } from "../components/funnel/types";
import {
  useReleaseDataQueryKey,
  useReleaseInfoDataQueryKey,
} from "../screens/reader/hooks/useReleaseDataQueryKey";
import { useRefetchQueries } from "../services/axiosInstance";

interface RefetchAccountAndReleaseOptions {
  invalidateUser?: boolean;
  invalidateReader?: boolean;
  invalidateReleaseInfo?: boolean;
  extraKeys?: (string | number | undefined)[][];
}
export function useRefetchAccountAndRelease(
  options?: RefetchAccountAndReleaseOptions,
) {
  const {
    invalidateUser = true,
    invalidateReader = true,
    invalidateReleaseInfo = true,
    extraKeys = [],
  } = options ?? {};

  const releaseDataQueryKey = useReleaseDataQueryKey();
  const releaseInfoQueryKey = useReleaseInfoDataQueryKey();
  const refetchQueries = useRefetchQueries(
    invalidateUser ? ACCOUNT_INIT_QUERY_KEY : [],
    invalidateReader ? (releaseDataQueryKey as string[]) : [],
    invalidateReleaseInfo ? releaseInfoQueryKey : [],
    ...extraKeys,
  );

  const refetch: () => Promise<AuthInvalidationTypes> = async () => {
    const refreshResults = await refetchQueries();
    return [refreshResults[0], refreshResults[2] ?? refreshResults[1]];
  };

  return refetch;
}
